/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DismissInvoiceDocument } from '../../models/dismiss-invoice-document';
import { InvoiceDocument } from '../../models/invoice-document';

export interface DismissInvoiceDocument$Params {
  uuid: string;
      body: DismissInvoiceDocument
}

export function dismissInvoiceDocument(http: HttpClient, rootUrl: string, params: DismissInvoiceDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocument>> {
  const rb = new RequestBuilder(rootUrl, dismissInvoiceDocument.PATH, 'patch');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InvoiceDocument>;
    })
  );
}

dismissInvoiceDocument.PATH = '/invoice-document/{uuid}/dismiss';
